module.exports = __webpack_public_path__ + "img/photo-9-1.290b9829.jpg";